// src/components/GlobalFont.jsx
import { useEffect } from "react";

export default function GlobalFont() {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href="https://fonts.googleapis.com/css2?family=Oxanium:wght@200..800&family=Qwigley&family=The+Nautigal:wght@400;700&display=swap"
    document.head.appendChild(link);

    // cleanup when the component unmounts
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // nothing visible to render
  return null;
}